/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M570.24 512l259.2 259.2-58.88 58.24L512 570.24 250.88 831.36l-58.24-58.24L453.76 512l-259.2-259.2 58.24-58.24L512 453.76l261.12-261.12 58.24 58.24z"/>'
  }
})
